import React from 'react';

export default function IndexSectionCtaWhitePattern10() {
    return (
        <React.Fragment>
            <>
                <section className="py-20 md:py-28 bg-white" style={{backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")', backgroundPosition: 'center'}}>
  <div className="container px-4 mx-auto">
    <div className="max-w-4xl mx-auto text-center">
      <h2 className="mb-4 text-3xl md:text-4xl font-heading font-bold">Das klingt fantastisch, aber wie kommen wir dahin?</h2>
      <p className="mb-6 text-lg md:text-xl font-heading font-medium text-coolGray-500">Gerne erläutern wir unseren Einführungsprozess und wie Sie Schritt für Schritt Deine Kreditorenbuchaltung revolutionieren.</p>
      <a className="inline-block py-3 px-7 w-full md:w-auto text-lg leading-7 text-green-50 bg-green-500 hover:bg-green-600 font-medium text-center focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 border border-transparent rounded-md shadow-sm" href="https://at-digitalsolutions.activehosted.com/f/6">Gleich loslegen</a>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

